// utils/dateUtils.js

/**
 * 根据传入的时间戳和当前时间比较，返回不同格式的日期字符串
 * @param {number} timestamp - 要处理的时间戳
 * @returns {string} - 格式化后的日期字符串
 */
export function formatDateByYearFull(timestamp) {
  // 默认为秒
  timestamp = timestamp * 1000;

  const targetDate = new Date(timestamp);

  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate()).padStart(2, "0");
  const hours = String(targetDate.getHours()).padStart(2, "0");
  const minutes = String(targetDate.getMinutes()).padStart(2, "0");
  const seconds = String(targetDate.getSeconds()).padStart(2, "0");

  const year = targetDate.getFullYear();
  return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
}
